<template>
	<div id="sjx">
		<div class="sjx_main">
			<div class="query_info">
				<!-- 报表类型 -->
				<el-button type="primary" @click="tagRead">标记已读</el-button>
				<el-button type="primary" @click="someDel(-1)">批量删除</el-button>
				<el-button type="primary" @click="getSjxInfo(true)">{{ msgType == 1 ? "全部消息" : "新消息" }}</el-button>
			</div>
			<!-- 彩票的表格 -->
			<div class="czTable">
				<el-table :data="czTableData" border stripe style="width: 100%">
					<el-table-column label="选择" width="100" align="center">
						<template slot-scope="scope">
							<div
								:class="scope.row.choosed ? 'choosed' : 'nochoose'"
								@click="changeChoosed(scope.$index, scope.row)"
							></div>
						</template>
					</el-table-column>
					<el-table-column prop="SendUName" label="发件人" />
					<el-table-column prop="Title" label="主题">
						<template slot-scope="scope">
							<div class="UmContent">{{ scope.row.Title }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="UmContent" label="内容">
						<template slot-scope="scope">
							<div class="UmContent">{{ scope.row.UmContent }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="CreateTime" width="170" label="时间" />
					<el-table-column prop="Flg" label="状态">
						<template slot-scope="scope">
							<span class="cancelState" v-if="scope.row.property === '已读'">已读</span>
							<span v-if="scope.row.property === '未读'">未读</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100" align="center">
						<template slot-scope="scope">
							<span class="to_view" @click="lookDetails(scope.row)">查看</span>
							<span class="to_del" @click="someDel(scope.row.UmId)">删除</span>
						</template>
					</el-table-column>
					<div slot="empty">
						<!-- 表格为空的样式 -->
						<div class="table-empty">
							<img src="@/static/img/zjzh/empty.webp" alt="" />
							<div class="table-empty-text">暂无记录</div>
						</div>
					</div>
				</el-table>
			</div>
			<div class="my-paging" v-show="czTableData.length != 0">
				<div class="everyPageShow">每页显示 10 条</div>
				<div class="totalNum">共{{ paginationArray.total }}条</div>

				<el-pagination
					@current-change="handleCurrentChange"
					:page-size="paginationArray.currpageSize"
					layout="prev, pager, next, jumper"
					:total="paginationArray.total"
					background
				/>
			</div>
		</div>
		<!-- 详细信息 -->
		<el-dialog title="消息详情" :visible.sync="dialogVisible">
			<div class="details_dialog"><span class="details_left">发件人：</span>{{ detailsInfo.SendUName }}</div>
			<div class="details_dialog">
				<span class="details_left">主题：</span>
				<div class="details_content">{{ detailsInfo.Title }}</div>
			</div>
			<div class="details_dialog">
				<span class="details_left">消息内容：</span>
				<div class="details_content">{{ detailsInfo.UmContent }}</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="pop_sure_btn" type="primary" @click="delDeatils">删除</el-button>
				<el-button class="pop_sure_btn pop_exit" type="primary" @click="dialogVisible = false">关闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
// 引用axios封装文件
import { postAjax } from "../../util/ajax.js";

export default {
	data() {
		return {
			msgType: 0,
			dialogVisible: false,
			//平台账号
			platformAccount: "",
			//日期
			beginDate: "",
			endDate: "",
			//表格数据
			czTableData: [
				{
					UmId: 2,
					Flg: false,
					choosed: false,
					platformAccount: "123",
					intoMoney: "￥500",
					outMoney: "￥300",
					betMoney: "￥300",
					winning: 0,
					rebates: 0,
					profitLoss: 0,
					SendUName: "111",
				},
			],
			paginationArray: {
				total: 0,
				currpageSize: 10,
				currPage: 1, //当前页数
			},
			//每页展示多少条
			pageSize: [
				{ value: 10, label: "10条" },
				{ value: 20, label: "20条" },
				{ value: 30, label: "30条" },
			],
			//详情信息
			detailsInfo: "",
		};
	},
	methods: {
		//改变分页条数
		pageChange(val) {
			this.paginationArray.currpageSize = val;
			this.getSjxInfo();
		},
		//得到收件箱的信息
		getSjxInfo(opt) {
			if (opt) {
				if (this.msgType == 1) {
					this.msgType = 0;
				} else {
					this.msgType = 1;
				}
			}
			let that = this;
			let url = "api/User/GetUserMessageInfo";
			let data = {
				Type: 1,
				PIndex: this.paginationArray.currPage,
				PSize: this.paginationArray.currpageSize,
			};
			that.czTableData = [];
			postAjax(url, data).then(function (data) {
				if (data.IsSucess) {
					//给数据加一个选中或未选中的字段
					for (var i = 0, length = data.Data.rows.length; i < length; i++) {
						data.Data.rows[i].choosed = false;
					}

					that.czTableData = data.Data.rows;
					if (that.msgType == 1) {
						that.czTableData = that.czTableData.filter(item => {
							return !item.Flg;
						});
					}

					that.paginationArray.total = data.Data.total;
				}
			});
		},
		//改变选中或未选中状态
		changeChoosed(index, row) {
			this.czTableData[index].choosed = !this.czTableData[index].choosed;
		},
		//标记已读
		tagRead() {
			if (this.getChoosedIds()) {
				let that = this;
				let url = "api/User/SetMessageRead?ids=" + this.getChoosedIds();
				postAjax(url, null).then(function (data) {
					if (data.IsSucess) {
						that.getSjxInfo();
					} else {
						that.$message.error("标记已读失败");
					}
				});
			} else {
				this.$message.error("请选择需要标记已读的数据");
			}
		},
		//查看详细信息
		lookDetails(info) {
			this.dialogVisible = true;
			this.detailsInfo = info;
			if (!info.Flg) {
				let url = "api/User/SetMessageRead?ids=" + info.UmId;
				postAjax(url, null).then(data => {
					if (data.IsSucess) {
						this.getSjxInfo();
					}
				});
			}
		},
		//查看详细信息的删除
		delDeatils() {
			this.del(this.detailsInfo.UmId);
			this.dialogVisible = false;
		},
		//删除
		someDel(umid) {
			//umid为-1表示批量删除，否则为单个删除
			if (umid == -1) {
				if (this.getChoosedIds().length > 0) {
					this.del(this.getChoosedIds());
				} else {
					this.$message.error("请选择需要批量删除的数据");
				}
			} else {
				this.del(umid);
			}
		},
		//删除请求的接口
		del(ids) {
			let url = "/api/User/DelMessages?ids=" + ids;
			postAjax(url, null).then(data => {
				if (data.IsSucess) {
					this.getSjxInfo();
				} else {
					this.$message.error("批量删除失败");
				}
			});
		},
		//得到已被选中的id
		getChoosedIds() {
			let ids = [];
			for (var i = 0, length = this.czTableData.length; i < length; i++) {
				if (this.czTableData[i].choosed) {
					ids.push(this.czTableData[i].UmId);
				}
			}
			return ids.join(",");
		},
		handleCurrentChange(e) {
			//回调为当前跳转的第几页
			this.paginationArray.currPage = e;
			this.getSjxInfo();
		},
		//时间格式化
		formatDate(row, column) {
			if (row[column.property]) {
				var arr = row[column.property].split("T");
				var arr1 = arr[1].split(".");
				return arr[0] + " " + arr1[0];
			} else {
				return "-";
			}
		},
		//格式化已读未读
		formatFlg(row, column) {
			return row[column.property] ? "已读" : "未读";
		},
	},
	mounted() {
		this.getSjxInfo();
	},
};
</script>
<style lang="scss">
.sjx_main {
	padding: 20px 0px 20px 0;
}

.to_view {
	margin-right: 10px;
	color: #0e78c7;
}

.to_view:hover {
	cursor: pointer;
}

.to_del:hover {
	cursor: pointer;
}

/*未选择的*/
.nochoose {
	width: 18px;
	height: 18px;
	border: 1px solid #b3b3b3;
	border-radius: 9px;
	display: inline-block;
	cursor: pointer;
}

.choosed {
	width: 18px;
	height: 18px;
	background-color: #0e78c7;
	border-radius: 50%;
	position: relative;
	cursor: pointer;
}

.choosed::after {
	content: "";
	border: 2px solid #fff;
	border-left: 0;
	border-top: 0;
	height: 8px;
	left: 6px;
	position: absolute;
	top: 3px;
	width: 4px;
	transition: transform 0.15s ease-in 0.05s;
	transform: rotate(45deg) scaleY(1);
	transform-origin: center;
}

.el-table .cell {
	display: flex;
	align-items: center;
	justify-content: center;
}

.czTable {
	.el-table .cell {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}

/*弹窗样式*/
#sjx .el-dialog__body {
	padding: 0;
}

#sjx .el-dialog__footer {
	padding: 25px 0 60px;
	text-align: center;
}

#sjx .pop_exit {
	background: #fafafa;
	color: #333;
	border: 0;
}

#sjx .details_dialog {
	display: flex;
	align-items: flex-start;
	margin-top: 20px;
	padding-left: 20px;
}

#sjx .details_left {
	width: 100px;
	text-align: right;
}

#sjx .details_content {
	width: 70%;
	height: 100%;
	display: flex;
	flex-wrap: wrap;
	word-break: break-all;
}

#sjx .UmContent {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/InfoCenter/sjx.vue